
<div class="row">
  <div class="col-12" *ngIf="!checkoutDTO.cart.items.length">
    <span>Your Cart is Empty</span>
    <span *ngIf="account && account.id == 1">&nbsp;&nbsp;:-(</span>
  </div>
</div>
<div class="row separate" *ngIf="checkoutDTO.cart.orderId">
  <div class="col-12">
    <div>
      <span>
        *You are editing Pre-Order #{{checkoutDTO.cart.orderId}}.
        To add items to this shipment or update your shipping and payment preferences hit "Update Order".
        We will charge your saved payment method on {{ shipDate | date:'longDate' }}.
        You may add items to this shipment or stop editing to place a new order.
      </span>
    </div>
  </div>

  <!-- STOP EDITING BUTTON -->
  <div class="col-md-6 col-lg-4" *ngIf="checkoutDTO.cart.orderId">
    <div class="pv-button warn" (click)="stopEditing()">Stop Editing This Shipment</div>
  </div>

  <!-- ADD ITEMS BUTTON -->
  <div class="col-md-6 col-lg-4" *ngIf="checkoutDTO.cart.orderId"></div>

  <!-- UPDATE SHIPPING AND PAYMENT -->
  <div class="col-md-6 col-lg-4" *ngIf="checkoutDTO.cart.orderId">
    <div class="pv-button">
      <a [routerLink]="['/cart', 'checkout']">Update Shipping And Payment Info</a>
    </div>
  </div>
</div>

<!-- LOYALTY POINTS -->
<div class="row" *ngIf="!isWholesale && checkoutDTO.cart.loyaltyPoints > 0">
  <div class="col-12">
    <!-- Not Logged In -->
    <!-- <p *ngIf="!checkoutDTO.customer.id"><a [routerLink]="['/login']">*Create an account or log in</a> and earn {{ checkoutDTO.cart.loyaltyPoints | number }} Reward Points with this order!</p> -->

    <!-- Logged In -->
    <!-- <p *ngIf="checkoutDTO.customer.id">*Earn {{ checkoutDTO.cart.loyaltyPoints | number }} <a [routerLink]="['/profile', 'points-shop']">Reward Points</a> with this order!</p> -->
  </div>
</div>

<div class="row">
  <div class="col-12" *ngIf="checkoutDTO.cart.items.length">
    <!-- HEADERS -->
    <div class="d-none d-md-block">
      <div class="row headers">
        <div class="col-3 offset-2 header">Item</div>
        <div class="col-1 offset-3 header">Quantity</div>
        <div class="col-2 offset-1 header">Price</div>
      </div>
    </div>

    <!-- TODO #900/719 GET/PRINT OUT THE NUMBER LEFT IN STOCK TO SEE AND COMPARE -->
    <!-- EACH ITEM -->
    <pv-cart-item *ngFor="let item of checkoutDTO.cart.items" [item]="item" (refresh)="onRefresh()"></pv-cart-item>

    <!-- BONUS ITEMS -->
    <pv-cart-item *ngFor="let item of checkoutDTO.cart.bonus" [item]="item" [bonus]="true"></pv-cart-item>

    <!-- TAX + TOTAL -->
    <div class="row total-border">

      <!-- SHOW FREE SHIPPING LABEL -->
      <div class="col-12 free-shipping" *ngIf="freeShippingLabel && freeShippingLabel.min_cart && !isInternational && !isWholesale">
        <div *ngIf="otherShippingLabel && moneyLeft > 20" class="accent-color">{{otherShippingLabel.flat_price | currency}} {{otherShippingLabel.label}}</div>
        <div *ngIf="!otherShippingLabel && moneyLeft > 20" class="accent-color">{{freeShippingLabel.label}}</div>
        <div *ngIf="moneyLeft <= 20 && moneyLeft > 0"><span class="accent-color">You're only {{freeShippingLabel.min_cart - itemTotal | currency}} away from {{freeShippingLabel.label}}</span></div>
        <div *ngIf="moneyLeft <= 0" class="accent-color">Congrats! You're eligible for {{ freeShippingLabel.label }}</div>
      </div>

      <div class="col-12 free-shipping" *ngIf="!freeShippingLabel && otherShippingLabel && !isInternational && !isWholesale">
        <div class="accent-color">{{otherShippingLabel.label}}</div>
      </div>

      <div class="col-12 free-shipping" *ngIf="freeShippingLabel && isWholesale">
        <div *ngIf="moneyLeft > 20" class="accent-color">{{freeShippingLabel.label}}</div>
        <div *ngIf="moneyLeft < 20 && moneyLeft > 0" class="accent-color">You're only {{ freeShippingLabel.min_cart - itemTotal | currency}} away from {{freeShippingLabel.label}}</div>
        <div *ngIf="moneyLeft <= 0" class="accent-color">Congrats! You're eligible for {{freeShippingLabel.label}}</div>

        <div *ngIf="otherShippingLabel" class="accent-color">{{otherShippingLabel.label || otherShippingLabel.label_international}}</div>
        <div *ngIf="otherShippingLabels" class="accent-color">
          <div *ngFor="let label of otherShippingLabels">
            {{label.label || label.label_international}}
          </div>
        </div>


      </div>

      <div class="col-12 col-md-3 offset-md-9 medium-total">
        <div *ngIf="taxRate"><span class="bold">Items:</span> {{ itemTotal | currency }}</div>
        <div *ngIf="taxRate"><span class="bold">Tax:</span> {{ taxRate * itemTotal | currency }}</div>
        <div><span class="bold">Cart Total:</span> {{ grandTotal | currency }}</div>
      </div>

      <div class="col-12 tax-calculated" *ngIf="!checkoutDTO.customer.id && moneyLeft > 0 || isInternational">
        Tax and shipping calculated at checkout
      </div>
    </div>

    <div *ngIf="errorMessage" class="error-message warn-color">
      {{ errorMessage }}
    </div>

    <!-- PREORDER WARNING -->
    <div class="row preorder-warning" *ngIf="hasPreorder() && !isWholesale">
      <div class="col-12">
        <span class="warn-color">ABOUT PRE-ORDERS:</span>
        <span>
          Your cart contains a pre-order. You may order other items along with your pre-order, however, the entire order will ship together on or before {{ shipDate | date:'longDate' }}. If you would like other items to ship earlier, please place an additional separate order for just those items.
        </span>
      </div>
    </div>

    <div class="row checkout-button">
      <div class="col-md-3 offset-md-6">
      </div>

      <div class="col-md-3">
        <div *ngIf="!checkoutDTO.cart.orderId" class="pv-button" [routerLink]="checkoutDTO.customer.id ? ['/cart', 'checkout'] : ['/cart', 'login']">Checkout</div>

        <div *ngIf="checkoutDTO.cart.orderId" class="pv-button" [routerLink]="checkoutDTO.customer.id ? ['/cart', 'checkout'] : ['/cart', 'login']">Update</div>
      </div>
    </div>
  </div>
</div>